module.exports = __webpack_public_path__ + "media/bootstrap-icons/clouds-c480490a.svg";